import {
  REJECT_REASON_EDIT, REJECT_REASON_EDIT_FAILURE, REJECT_REASON_EDIT_SUCCESS, REJECT_REASON_UPDATE, REJECT_REASON_UPDATE_FAILURE, REJECT_REASON_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    reject_reason: null
  },
  getters: {
    edit_reject_reason: state => {
      return state.reject_reason
    }
  },
  actions: {
    [REJECT_REASON_EDIT] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var callback = null
      if (data) {
        callback = data.callback
      }
      var url = '/master/reject_reasons/' + params.id
      dispatch('apiGet', {url: url, data: {reject_reason_id: params.reject_reason_id}, loadparams: true})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(REJECT_REASON_EDIT_FAILURE, res.data)
            } else {
              res.data.callback = callback
              commit(REJECT_REASON_EDIT_SUCCESS, res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [REJECT_REASON_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/master/reject_reasons/' + params.id
      dispatch('apiPatch', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(REJECT_REASON_UPDATE_FAILURE, res.data)
            } else {
              commit(REJECT_REASON_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [REJECT_REASON_EDIT_FAILURE] (state, data) {
      console.log('REJECT_REASON_EDIT_FAILURE')
    },
    [REJECT_REASON_EDIT_SUCCESS] (state, data) {
      console.log('REJECT_REASON_EDIT_SUCCESS')
      state.reject_reason = data
      if (data.callback) {
        data.callback()
      }
    },
    [REJECT_REASON_UPDATE_FAILURE] (state, data) {
      console.log('REJECT_REASON_UPDATE_FAILURE')
    },
    [REJECT_REASON_UPDATE_SUCCESS] (state, data) {
      console.log('REJECT_REASON_UPDATE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rejectreason-edit.js